import useAppContext from "@casino/legacy/shared/context/AppContext/useAppContext";

const DEFAULT_VALUE = { id: "", __typename: "Features" } as UserTags;

/**
 * The signed-in user's tags, fetched on the server by `PagesRouterAdapter`.
 * After toggling a tag, call `router.refresh()` (or keep local state) rather
 * than expecting this to update.
 */
const useTags = (): UserTags => {
  const { userTags } = useAppContext();
  return userTags ?? DEFAULT_VALUE;
};

export default useTags;
